/*
akhila 10/27/2022 2701012930  bre UX Changes
Ashraf 11/19/2022 2701012930  resetting formula redux data
Rajesh 12/02/2022 2701012930 changed side nav
Rohini 12/05/2022 2701012930 changed side nav format
Ashraf 12/05/2022 2701012930 Fixed header labels

 */
import React, {useContext, useEffect, useState} from 'react';
import {makeStyles} from '@material-ui/core/styles';
import RuleGroup from './FormulaRuleGroup/index';
import FilterRuleGroup from './FilterRuleGroup/index';
import SelectTabContextProvider from '../../../components/SelectTabContext/SelectTabContext';
import {setReduxState} from '../../../redux/reducers/BRE/AddRuleGroup';
import {useDispatch} from 'react-redux';
import LandingPage from '../../../Pages/LandingPage';
import {useLocation} from 'react-router';

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    width: '100%',
    borderRadius: '5px',
  },
  padding: {
    padding: theme.spacing(3),
  },
  demo1: {
    backgroundColor: '#296bff',
    color: 'white',
    borderRadius: '6px',
  },
}));

export default function BreTabs() {
  const classes = useStyles();
  const location = useLocation();
  // const [groupId, setGroupId] = useState('');
  const groupId = '';
  // const [RMbreCode, setBreCode] = useState(null);
  const RMbreCode = null;
  const [value, setValue] = useState(0);
  const [value1, setValue1] = useState(0);
  const {editRuleGroupId} = useContext(SelectTabContextProvider);
  const dispatch = useDispatch();
  useEffect(() => {
    if (editRuleGroupId) {
      setValue(1);
    }
  }, []);
  console.log(location);
  useEffect(() => {
    dispatch(setReduxState({property: 'formData', value: {}}));
    dispatch(setReduxState({property: 'category', value: ''}));
  }, [value]);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  const handleChange1 = (event, newValue) => {
    setValue1(newValue);
  };
  const tabLabels = ['Data Calculations'];
  const tabLabels1 = ['Filter Rules'];
  return (
    <>
      <LandingPage
        title={'Business Rules'}
        showTabs={true}
        tabValue={value ? value : value1}
        handleTabChange={
          location.pathname === '/frameworks/data-calculation' ? handleChange : handleChange1
        }
        allAntTabs={location.pathname === '/frameworks/data-calculation' ? tabLabels : tabLabels1}
      >
        <div className={`global-field-dash-board`}>
          <div className={` ${classes.cardStyleWhite}`}>
            <div className={classes.root}>
              <div className={classes.subContent}>
                {value === 0 && location.pathname === '/frameworks/data-calculation' && (
                  <RuleGroup setTabValue={setValue} groupId={groupId} RMbreCode={RMbreCode} />
                )}
                {value1 === 0 && location.pathname === '/frameworks/filter-rules' && (
                  <FilterRuleGroup
                    setTabValue={setValue1}
                    groupId={groupId}
                    RMbreCode={RMbreCode}
                  />
                )}
              </div>
            </div>
          </div>
        </div>
      </LandingPage>
    </>
  );
}
